module.exports = __webpack_public_path__ + "static/dining3-aa9c5da19c34b35d726ed9074abca201.jpg";